import React from 'react'
import IndustryMatrix from './components/IndustryMatrix'
import LandingHero from './components/LandingHero'
import { ParallaxProvider } from 'react-scroll-parallax'

const LandingPage = ({ props, data }) => <div className='page-container landing'>
  <ParallaxProvider>
    <LandingHero
      headline={data.landing_page.title}
      body={data.landing_page.desc}
      industries={data.industries}
    />
    <IndustryMatrix industries={data.industries} narratives={data.narratives} times={data.times} headline={data.landing_page} {...props} />
  </ParallaxProvider>
</div>

export default LandingPage
